import { render, staticRenderFns } from "./SupportInfoDialog.vue?vue&type=template&id=373dae16&scoped=true"
import script from "./SupportInfoDialog.vue?vue&type=script&lang=js"
export * from "./SupportInfoDialog.vue?vue&type=script&lang=js"
import style0 from "./SupportInfoDialog.vue?vue&type=style&index=0&id=373dae16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "373dae16",
  null
  
)

export default component.exports